import { render, staticRenderFns } from "./AlertsModal.vue?vue&type=template&id=6d8a8799&scoped=true&"
import script from "./AlertsModal.vue?vue&type=script&lang=js&"
export * from "./AlertsModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertsModal.vue?vue&type=style&index=0&id=6d8a8799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a8799",
  null
  
)

export default component.exports